<app-header></app-header>
<app-page-title></app-page-title>

<div class="col-lg-12">

    <div class="row">
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label">Select Region</div>
      <select [(ngModel)]="regionFilter" class="form-control" (change) = "getCategoryList($event)">
        <option value="">All Region </option>
        <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label">Category Type</div>
      <select [(ngModel)]="categoryFilter" class="form-control" (change) = "getTimeUnitList($event)">
        <option value="">All Category Type </option>
        <option *ngFor="let category of categoryList"  value="{{category.industry_category}}">{{category.industry_category}}</option>
      </select>
    </div>
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label">Industry Type</div>
       <select [(ngModel)]="unitTypeFilter" class="form-control" (change) = "getVendorList($event)">
         <option value=""> All Industry Type </option>
        <option *ngFor="let item of timeUnitList"  value="{{item.stdunit}}"> {{item.stdunit}} </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label">Vendor</div>
      <select [(ngModel)]="vendorFilter" class="form-control" (change) = "getIndustryList($event)">
        <option value="">All Vendor</option>
        <option *ngFor="let vendor of vendorList"  value="{{vendor.id}}"> {{vendor.vendor_name}} </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label"> Industry</div>
      <!-- <select [(ngModel)]="industryFilter" class="form-control" (change) = "getStationList($event)">
        <option value=""> All Industry </option>
        <option *ngFor="let industry of industryList"  value="{{industry.id}}"> {{industry.name}} </option>
      </select> -->
      <ng-multiselect-dropdown
         class="form-control multi"
         [data]="industryList"
         [(ngModel)]="industryFilter"
         [settings]="industrySettings"
         >
      </ng-multiselect-dropdown>
    </div>
  </div>


    <div class="col-lg-12 center m-y">
      <button class="btn btn-primary" (click)="getExceededIndustry()" > <i class="icon icon-search4"></i> Search </button>
    </div>
  </div>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">

        <div *ngIf="firstLevelExceedance" class="panel panel-flat">
          <div class="panel-heading">
            <h5 class="panel-title">
              <span>Detailed OCEMS industry report of {{regionFilter}} Region as on {{currentDate}}
                .</span>
              <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
            </h5>
          </div>

          <table *ngIf="!regionLoaderExceedance" class="table datatable-show-all">
            <thead>
            <tr>
              <th>HROCMMs ID</th>
              <th>Industry name</th>
              <th>Industry address</th>
              <th>Region</th>
              <th>Category Type</th>
              <th>Vendor name</th>
              <th>Detail</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>{{regionFilter}}</td>
                <td>{{categoryFilter}}</td>
                <td>{{vendorFilter}}</td>
                <td>
                    <a  data-toggle="modal" data-target="#secondLevel">View</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="regionLoaderExceedance">
            <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
              <div style="margin-top: 50px;">
                <img src="/assets/images/load.gif" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!firstLevelExceedance"  class="col-lg-12 text-center" style="height: 180px;">
          <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
            No Industry Station Report Found
          </div>
        </div>

        <div id="secondLevel" class="modal fade" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="closeModal" data-dismiss="modal">&times;</button>
                <div class="panel-heading">
                  <h5 class="panel-title">
                   </h5>
                </div>
               </div>
              <div class="modal-body">
                <div>
                  <div class="form-horizontal">
                    <fieldset class="content-group">

                      <div class="form-group">
                        <label class="control-label col-lg-2">
                          Sub Region
                        </label>
                        <div class="col-lg-10">
                          <select [(ngModel)]="subRegion" class="form-control">
                            <option value="">All Sub Region </option>
                            <option value="1">Sub Region 1 </option>
                            <option value="2">Sub Region 2 </option>
                            <option value="3">Sub Region 3 </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label col-lg-2">
                          Is Government Department
                        </label>
                        <div class="col-lg-10">
                          <div class="form-group">
                            <label class="radio-inline">
                              <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="isGovDept" value="yes" type="radio" name="radio-inline-left" class="styled choice" checked="checked">
                              Yes
                            </label>

                            <label class="radio-inline">
                              <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="isGovDept"  value="no" type="radio" name="radio-inline-left" class="styled choice">
                              No
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="form-group" *ngIf="isGovDept=='yes'">
                        <label class="control-label col-lg-2">
                         Select Department
                        </label>
                        <div class="col-lg-10">
                          <select [(ngModel)]="selectedDept" class="form-control">
                            <option value=""> Select Department </option>
                            <option value="PHED">PHED </option>
                            <option value="HSVP">HSVP </option>
                            <option value="ULB">ULB </option>
                            <option value="HSIIDC">HSIIDC  </option>
                            <option value="GMDA">GMDA</option>
                            <option value="Garrison">Garrison  </option>
                            <option value="Other">Other </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label col-lg-2">
                          Locality  of unit
                        </label>
                        <div class="col-lg-10">
                          <select [(ngModel)]="selectedLocality" class="form-control">
                            <option value=""> Select Locality </option>
                            <option value="HSIIDC">HSIIDC industrial area </option>
                            <option value="HSVP">HSVP industrial area </option>
                            <option value="ULB">ULB industrial area </option>
                            <option value="other">other industrial Cluster </option>
                          </select>
                        </div>
                      </div>

                      <div *ngIf="selectedLocality=='other'" class="form-group">
                        <label class="control-label col-lg-2">
                          Other industrial Area Detail
                        </label>
                        <div class="col-lg-10">
                          <input autocomplete="off" pattern="^[^<>]*$" type="text" [(ngModel)]="otherIndustryDetail" placeholder="Enter Other industrial Area Detail" class="form-control">
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label col-lg-2">
                          District of unit
                        </label>
                        <div class="col-lg-10">
                          <input autocomplete="off" pattern="^[^<>]*$" type="text" [(ngModel)]="districtOfUnit" placeholder="Enter District of unit" class="form-control">
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="form-horizontal">

                    <fieldset class="content-group">
                      <div class="form-group">
                        <div class="col-lg-12" *ngIf="!addDetailLoader">

                          <div class="col-lg-1 pull-right">
                            <button type="submit" class="btn btn-primary">
                              <strong>Add</strong>
                            </button>
                          </div>

                          <div class="col-lg-1 pull-right">
                            <button type="button" class="btn btn-danger">
                              <strong>Reset</strong>
                            </button>
                          </div>
                        </div>

                        <div class="col-lg-12" *ngIf="addDetailLoader">
                          <span class="pull-right"><img style="width: 60%;" src="/assets/images/load.gif" /></span>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


